import { find } from "../utils/dom";

const global = () =>{
	$(document).ready(function(){
		//ANCORA
		$(".link-scroll").click(function(){
			$('html,body').animate({scrollTop:$(this.hash).offset().top - 85}, 700);
			$(".menu-mobile").fadeOut(300);
			$(".open-menu").removeClass("active");
			return false;
		});

		//menu
		$(".open-menu").click(function(){
			$(".menu-mobile").fadeToggle(300);
			$(this).toggleClass("active");
			return false;
		});

		//TEL
		var SPMaskBehavior = function (val) {
			return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
		},
		spOptions = {
			onKeyPress: function(val, e, field, options) {
				field.mask(SPMaskBehavior.apply({}, arguments), options);
			}
		};
		$(".tel").mask(SPMaskBehavior, spOptions);

		$(window).scroll(function(){
			if($(this).scrollTop() > 5){
				$("header").addClass("fix");
			} else {
				$("header").removeClass("fix");
			}
		})

		new WOW().init();
	});
}

export default global;